var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "input-group select2-input-container" }, [
    _c("select", { ref: "select2", staticClass: "form-control" }),
    _vm._v(" "),
    _c("span", { staticClass: "input-group-btn" }, [
      _vm.allowEdit && _vm.editFormBaseEndPoint !== undefined
        ? _c(
            "button",
            {
              staticClass: "btn blue action-edit",
              staticStyle: { margin: "0" },
              attrs: { type: "button" },
              on: { click: _vm.editItem },
            },
            [_c("i", { staticClass: "fa fa-edit" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.allowAdd && _vm.addFormBaseEndPoint !== undefined
        ? _c(
            "button",
            {
              staticClass: "btn yellow action-add",
              staticStyle: { margin: "0" },
              attrs: { type: "button" },
              on: { click: _vm.addItem },
            },
            [_c("i", { staticClass: "fa fa-plus" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.allowQuickAdd &&
      _vm.type === "part" &&
      _vm.addFormBaseEndPoint !== undefined
        ? _c(
            "button",
            {
              staticClass: "btn blue action-quick-add",
              staticStyle: { margin: "0" },
              attrs: { type: "button", title: "Création rapide" },
              on: { click: _vm.quickAddItem },
            },
            [_c("i", { staticClass: "fa fa-bolt" })]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }